import { render, staticRenderFns } from "./iconBox1.vue?vue&type=template&id=2599b72c&scoped=true"
import script from "./iconBox1.vue?vue&type=script&lang=js"
export * from "./iconBox1.vue?vue&type=script&lang=js"
import style0 from "./iconBox1.vue?vue&type=style&index=0&id=2599b72c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2599b72c",
  null
  
)

export default component.exports